import { ONE_HOUR } from "@/constants/Time";

export const DEFAULT_REFERENTIALS_STALE_TIME = ONE_HOUR;
